import React from "react";
import { siteConfig } from "@/data/site";

const SiteFooter = () => {
  return (
    <footer className="border-t border-gray-200 dark:border-gray-800">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="flex flex-col gap-3 md:flex-row md:items-center md:justify-between text-sm text-gray-500 dark:text-gray-400">
          <div className="flex flex-wrap items-center gap-2">
            <span>© {new Date().getFullYear()} {siteConfig.name}</span>
            <span>•</span>
            <span>Built with love, coffee, and code</span>
          </div>
          <div className="flex items-center gap-4">
            <a
              href={siteConfig.social.github}
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-gray-900 dark:hover:text-gray-200 transition-colors"
            >
              GitHub
            </a>
            <a
              href={siteConfig.social.linkedin}
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-gray-900 dark:hover:text-gray-200 transition-colors"
            >
              LinkedIn
            </a>
            <a
              href={`mailto:${siteConfig.email}`}
              className="hover:text-gray-900 dark:hover:text-gray-200 transition-colors"
            >
              Email
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default SiteFooter;
